import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();

const Emitter = {
  on: (event, fn, ctx) => eventEmitter.on(event, fn, ctx),
  once: (event, fn, ctx) => eventEmitter.once(event, fn, ctx),
  off: (event, fn, ctx) => eventEmitter.off(event, fn, ctx),
  emit: (event, payload?) => eventEmitter.emit(event, payload)
};

Object.freeze(Emitter);

export default Emitter;

// ref: https://medium.com/@krzakmarek88/eventemitter-instead-of-lifting-state-up-f5f105054a5
